var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoins(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.773,
    height: 41.046,
    viewBox: "0 0 33.773 41.046",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9ae236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8acd2e"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "coins",
    d: "M5299.993,7070.045a2.668,2.668,0,0,1-2.553-2.809c0-2.521-.125-3.128.544-4.036a2.769,2.769,0,0,1-.544-1.652c0-2.472-.111-3.292.488-4.1a2.9,2.9,0,0,1-.614-1.851h2.133c0,.438.244.876.41.876H5316c.821,0,.637-1.095.637-2.851a.621.621,0,0,0-.5-.651H5308.1v-2.187h8.027c.167,0,.5-.337.5-.771v-2.08a.623.623,0,0,0-.5-.652h-4.189V7045.1h3.41c.671,0,1.281-.441,1.281-.771v-2.08c0-.328-.61-.65-1.281-.65h-5.3s.008.168.008.265A12.531,12.531,0,1,1,5297.528,7029a12.455,12.455,0,0,1,12.291,10.407h5.531c1.832,0,3.413,1.242,3.413,2.84,0,2.178.144,2.844-.635,3.779a3.123,3.123,0,0,1,.635,1.911c0,2.139.127,2.91-.556,3.885a3.149,3.149,0,0,1,.556,1.8c0,2.14.126,2.9-.551,3.876a2.776,2.776,0,0,1,.551,1.664c0,2.521.125,3.128-.544,4.034.669.908.544,1.514.544,4.036a2.847,2.847,0,0,1-2.769,2.809Zm.125-5.689a.552.552,0,0,0-.545.56v2.381c0,.789-.3.56,16.513.56a.552.552,0,0,0,.546-.56v-2.381c0-.5.12-.591-4.049-.591C5310.163,7064.324,5306.3,7064.355,5300.118,7064.355Zm0-5.69a.552.552,0,0,0-.545.56v2.382c0,.788-.3.561,16.513.561a.554.554,0,0,0,.546-.561v-2.382c0-.5.12-.591-4.049-.591C5310.163,7058.634,5306.3,7058.665,5300.118,7058.665Zm-12.985-16.838a10.4,10.4,0,1,0,10.4-10.668A10.547,10.547,0,0,0,5287.133,7041.827Zm9.455,7.209v-1.367a4.408,4.408,0,0,1-4.064-2.958l2.172-.944c1,2.415,5.282,2.043,5.282.226,0-2.373-6.9.045-6.9-4.764,0-1.785,1.379-3.031,3.512-3.361v-1.274h2.132v1.281a3.737,3.737,0,0,1,3.2,2.208l.184.2-2,.949c-1.042-1.768-4.645-1.549-4.645,0,0,2.134,6.92-.187,6.92,4.764,0,2.227-1.527,3.4-3.659,3.6v1.441Z",
    transform: "translate(-5285.001 -7028.999)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.7e245c75.svg";
export { ForwardRef as ReactComponent };